export default () => {
  return {
    users: [],
  };
};
